import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import LeiService from '../../../../services/leis';
import Lei from './lei';


const ListarLeis = () => {

    const [leis, setLeis] = useState([]);


    async function fetchLeisIn() {
        const response = await LeiService.categorias({ categoria: "Lei Municipal" });
        setLeis(response.data)
    }

    useEffect(() => {
        fetchLeisIn();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <Row xs={2} lg={6}>
                    {leis.map((lei, index) =>
                        <Lei
                            lei={lei}
                            key={index}
                        />
                    )}
                </Row>
            </Fragment>
        </Fragment>

    )
}

export default ListarLeis;